import styled from "@emotion/styled";
import React from "react";

import Lottie from "react-lottie";
import GiftBoxLottie from "../../../public/assets/lotties/gift-box-with-confetti.json";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppButton } from "../Generic/AppButton";
import { AppCard, AppCardContent } from "../Generic/AppCard";
import Flex from "../Generic/Flex";
import GenericSettingsScreen from "../GenericSettingsScreen";
import { default as AirpodsIcon } from "/public/assets/airpods-pro.svg?react";
import { default as AmazonIcon } from "/public/assets/amazon.svg?react";
import { default as DollarIcon } from "/public/assets/money.svg?react";
import { default as StarbucksIcon } from "/public/assets/starbucks.svg?react";

interface Props {
  caregiverPoints: number;
  onClickGetNow: (reward: string) => void;
  onClickGoBack: () => void;
}

const lottieOptions = {
  loop: false,
  autoplay: true,
  animationData: GiftBoxLottie,
};

const CarebackPointsScreen = (props: Props) => {
  const Rewards = [
    {
      id: 1,
      icon: DollarIcon,
      title: translate(STRINGS.CAREBACK_CASH_BONUS),
      subtitle: translate(STRINGS.EACH_100_POINTS_DOLLAR),
    },
    {
      id: 2,
      icon: AmazonIcon,
      title: translate(STRINGS.FIFTHY_DOLLAR_AMAZON_GIFT_CARD),
      subtitle: translate(STRINGS.FIVE_THOUSAND_POINTS),
    },
    {
      id: 3,
      icon: StarbucksIcon,
      title: translate(STRINGS.TEN_DOLLAR_STARBUCKS_GIFT_CARD),
      subtitle: translate(STRINGS.ONE_THOUSAND_POINTS),
    },
    {
      id: 4,
      icon: AirpodsIcon,
      title: translate(STRINGS.AIRPODS),
      subtitle: translate(STRINGS.FOURTEEN_THOUSAND_POINTS),
    },
  ];
  return (
    <GenericSettingsScreen
      title={translate(STRINGS.POINTS_AND_REWARDS)}
      onClickGoBack={props.onClickGoBack}
    >
      <Flex alignItems="center" justifyContent="center" direction="column">
        <Lottie options={lottieOptions} height="45%" width="45%"></Lottie>
        <CarebackPointsScreen.Points>{props.caregiverPoints}</CarebackPointsScreen.Points>
        <span>{translate(STRINGS.AVAILABLE_CARE_POINTS)}</span>
      </Flex>

      {Rewards.map((reward) => (
        <CarebackPointsScreen.Styled key={reward.id}>
          <CarebackPointsScreen.Content>
            <Flex direction="row" xGap={16} alignItems="center" justifyContent="center">
              <reward.icon height={32} width={32}></reward.icon>

              <CarebackPointsScreen.ContentWrapper>
                <CarebackPointsScreen.Title>{reward.title}</CarebackPointsScreen.Title>
                <CarebackPointsScreen.Subtitle>{reward.subtitle}</CarebackPointsScreen.Subtitle>
              </CarebackPointsScreen.ContentWrapper>
            </Flex>

            <CarebackPointsScreen.GetNowButton onClick={() => props.onClickGetNow(reward.title)}>
              {translate(STRINGS.GET_NOW)}
            </CarebackPointsScreen.GetNowButton>
          </CarebackPointsScreen.Content>
        </CarebackPointsScreen.Styled>
      ))}
    </GenericSettingsScreen>
  );
};

CarebackPointsScreen.ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

CarebackPointsScreen.Title = styled.span`
  font-size: 14px;
  white-space: nowrap;
`;

CarebackPointsScreen.Points = styled.span`
  font-size: 36px;
  font-weight: 800;
`;

CarebackPointsScreen.Subtitle = styled.span`
  color: var(--gray-500);
  font-size: 12px;
  white-space: nowrap;
`;

CarebackPointsScreen.Styled = styled(AppCard)`
  margin-top: 12px;

  .AppCardContent {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`;

CarebackPointsScreen.Content = styled(AppCardContent)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

CarebackPointsScreen.GetNowButton = styled(AppButton)`
  display: flex;
  align-items: center;
  justify-content: end;
  font-size: 10px;
  white-space: nowrap;
  height: 25px;
  width: 70px;
`;

export default CarebackPointsScreen;
